<div class="prelogin-eligibility-popup-wrapper">
  <div class="close" [class.dark]="!data?.customExternalEligibility && componentData?.eligibility?.darkMode">
    <mat-icon role="button" aria-label="close" tabindex="0" (accessibleClick)="onClose()">close</mat-icon>
  </div>
  <ten-default-eligibility-check
    *ngIf="
      !data?.customExternalEligibility &&
      componentData?.eligibility &&
      componentData?.eligibility.version === 'ten-default-eligibility-check'
    "
    [darkMode]="componentData?.eligibility?.darkMode"
    [data]="componentData?.eligibility?.data"
    (closePreloginPopup)="onClose()"
  >
  </ten-default-eligibility-check>
  <ten-visa-eligibility-check *ngIf="data?.customExternalEligibility" (closePreloginPopup)="onClose()">
  </ten-visa-eligibility-check>
</div>
